import { render, staticRenderFns } from "./BHome.vue?vue&type=template&id=36ca3ad9&"
import script from "./BHome.vue?vue&type=script&lang=js&"
export * from "./BHome.vue?vue&type=script&lang=js&"
import style0 from "./BHome.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports